import TablePagination from '../component/TablePagination';
import { newestOrderFirst } from '../utils/orderSort';
import React, { useEffect, useState } from 'react';
import Layout from '../component/Layout';
import { ArrowUpTrayIcon, BellAlertIcon, EllipsisVerticalIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { deleteOrder, getAllOrders, getAllOrdersByBusiness, getAllPendingOrders, getAllPendingOrdersByBusiness, listOrderStatus, updateItemQuantity, updateOrderStatus } from '../adapter/api';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./OrderModals.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import AsyncStorage from '@react-native-async-storage/async-storage';

const AllOrders = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentItem, setCurrentItem] = useState(null);
  const [newQuantity, setNewQuantity] = useState(0);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [rowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [statuses, setStatuses] = useState([])
  const [selectedItem, setSelectedItem] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const selectedStatus = selectedOrder?.orderStatus?.name || "";

  // Inside the component function
  const exportToPDF = () => {
    const doc = new jsPDF();

    // Adding title to PDF
    doc.text("All Orders", 20, 20);

    // Set up headers for the table
    const headers = ["#", "Status", "Date", "Time", "Customer Name", "Customer No.", "Driver Name", "Driver No."];

    // Create rows dynamically based on orders
    const rows = currentOrders.map(order => [
      order.orderNumber,
      order.orderStatus?.name,
      formatDate(order.date),
      order.timeCreated,
      order.customerName,
      order.customerPhoneNumber,
      order.driverName,
      order.driverPhoneNumber
    ]);

    // Add the table to the PDF
    doc.autoTable({
      head: [headers],
      body: rows,
      startY: 30, // The Y position where the table starts
    });

    // Save the PDF to the local system
    doc.save("all_orders.pdf");
  };

  const handleEditOrder = async () => {
    setIsModalOpen(false)
    toast.success("Saved!")
  }

  const handleDeleteClick = (item) => {
    toggleDropdown(null)
    setSelectedItem(item);
    setShowConfirmModal(true);
  };


  const formatDate = (value) => {
    const current = new Date(value);
    return current.toLocaleDateString('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const toggleDropdown = (id) => setDropdownOpenId(dropdownOpenId === id ? null : id);



  // Derived states
  const filteredOrders = orders.filter((order) => {
    const search = searchTerm.toLowerCase();
    return (
      order.orderNumber?.toString().toLowerCase().includes(search) ||
      order.customerName?.toLowerCase().includes(search) ||
      order.customerPhoneNumber?.toLowerCase().includes(search) ||
      order.driverName?.toLowerCase().includes(search) ||
      order.driverPhoneNumber?.toLowerCase().includes(search) ||
      order.orderStatus?.name?.toLowerCase().includes(search) ||
      formatDate(order.date).toLowerCase().includes(search) ||
      order.timeCreated?.toLowerCase().includes(search) ||
      order.businessName?.toLowerCase().includes(search)
    );
  }).sort(newestOrderFirst);

  const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);
  useEffect(() => {
    setCurrentPage(page => Math.min(page, Math.max(1, totalPages)));
  }, [totalPages]);
  const currentOrders = filteredOrders.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleGetOrderByStatus = async () => {
    setLoading(true)
    if (userRole === 'ROLE_BUSINESS') {
      const response2 = await getAllOrdersByBusiness(phoneNumber);
      setOrders(response2.data.data);
    } else {
      const response2 = await getAllOrders();
      setOrders(response2.data.data);
    }
    setLoading(false)
  };

  const confirmDelete = () => {

    handleDeleteOrder(selectedItem);

  };

  const handleDeleteOrder = async (order) => {
    try {

      const response = await deleteOrder(order.orderId);
      if (response.data.status) {

        toast.success("Order Deleted!");
        setShowConfirmModal(false)
        handleGetOrderByStatus()


      }
    } catch (error) {
      toast.error("Error deleting item!");
      console.error("Delete error:", error);
    }
  }
  const cancelDelete = () => {
    setShowConfirmModal(false);
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalImageOpen, setIsModalImageOpen] = useState(false);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsModalImageOpen(true);
  };

  const closeModalImage = () => {
    setIsModalImageOpen(false);
    setSelectedImage(null);
  };

  useEffect(() => {
    const fetchUserRole = async () => {
      setLoading(true);

      try {
        const user = await AsyncStorage.getItem("myUser");
        if (user) {
          const parsedUser = JSON.parse(user);
          const { role, email } = parsedUser;

          setUserRole(role); // Set the role from AsyncStorage
          setPhoneNumber(email);

          if (role === 'ROLE_BUSINESS') {
            const response2 = await getAllOrdersByBusiness(email); // Use `email` directly
            setOrders(response2.data.data);
          } else if (role === 'ROLE_ADMIN') {
            const response2 = await getAllOrders();
            setOrders(response2.data.data);
          }
        }
      } catch (error) {
        console.error("Error fetching user role:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserRole();

    // Additional side effects
    handleGetStatus();
  }, []); // Dependencies


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };


  const handleEditItem = (item) => {
    setCurrentItem(item);
    setNewQuantity(item.quantity);
    setIsEditModalOpen(true);
  };

   const handleSaveQuantity = async (customer) => {
 
     if (currentItem) {
       currentItem.quantity = newQuantity; // Update the item quantity locally
        
       if(newQuantity != ""){
        
         const response = await updateItemQuantity(selectedOrder.orderId,currentItem.product.productId, newQuantity) 
         
         if(userRole === 'ROLE_BUSINESS'  ){
           const response2 = await getAllPendingOrdersByBusiness(phoneNumber);
           setOrders(response2.data.data);
         }else{
           const response2 = await getAllPendingOrders();
           setOrders(response2.data.data);
         }
         
         toast.success("Quantity edited!")
        
 
       }
     }
     setIsEditModalOpen(false); // Close the modal after saving
     setIsModalOpen(false)
 
   };


  const handleDeleteItem = (index) => {
    console.log("Delete item at index:", index);
    // Implement the logic to delete the item
    // For example, you can update the items array:
    const updatedItems = selectedOrder.items.filter((_, i) => i !== index);
    setSelectedOrder({ ...selectedOrder, items: updatedItems });
  };


  const openModal = (order) => {
    toggleDropdown(null)
    setSelectedOrder(order); // Set the selected order to display its details
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null); // Clear selected order when closing the modal
  };

  const changeOrderStatus = async (val) => {

    const body =
    {
      "orderStatus": {
        "orderStatus_id": val.value
      }
    }

    const response = await updateOrderStatus(selectedOrder.orderId, val.value)
    if (response.status) {
      toast.success("Status Updated Successfully!");
      setIsModalOpen(false)
      if (userRole === 'ROLE_BUSINESS') {
        const response2 = await getAllOrdersByBusiness(phoneNumber);
        setOrders(response2.data.data);
      } else {
        const response2 = await getAllOrders();
        setOrders(response2.data.data);
      }



    }





  }


  const handleGetStatus = async () => {
    const response = await listOrderStatus();
    statuses.length = 0
    for (var j = 0; j < response.data.data.length; j++) {
      const data = {
        label: response.data.data[j].name,
        value: response.data.data[j].orderStatus_id
      }
      statuses.push(data)
    }
    setStatuses(statuses);
  }



  const getStatusClass = (status) => {
    switch (status) {
      case 'Pending':
        return 'bg-customColor text-yellow';
      case 'Cancelled':
        return 'bg-lightRed text-red';
      case 'Confirmed':
        return 'bg-lightBlue text-blue';
      default:
        return 'bg-lightGreen text-green';
    }
  };


  return (
    <Layout>
      <ToastContainer />
      <h1 className="text-2xl font-medium mb-4 mt-7 font-inter text-lg">All Orders</h1>
      {/* Page content goes here */}
      <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

      <div className="data-card overflow-x-auto mt-4 rounded-lg">
        <div className="data-toolbar bg-grey flex justify-between items-center mb-0 w-full border-t border-l pl-3 border-r pr-3 pt-3 border-gray-200">

          <div className="w-1/3 pb-3">
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search orders…" aria-label="Search orders"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="npb-3">
            <button onClick={exportToPDF}
              className="px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <ArrowUpTrayIcon className="h-4 w-4 mr-2 mt-0.4" />
              Export
            </button>
          </div>
        </div>


        {loading && <div class="animate-pulse">
          <div class="h-4 bg-gray-200 mt-3 mb-6 pb-9"></div>
          <div class="h-4 bg-gray-300 mb-6 pb-9"></div>
          <div class="h-4 bg-gray-200 mb-6 pb-9"></div>
          <div class="h-4 bg-gray-300 mb-6 pb-9"></div>
          <div class="h-4 bg-gray-200 mb-6 pb-9"></div>
        </div>}


        {!loading && <table className="data-table  min-w-full bg-white border-b border-r border-l border-gray-200 shadow-sm">
          <thead>
            <tr className="bg-grey border-b">
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700"></th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">#</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Status</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Date</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Time</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Store</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Customer Name</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Customer No.</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Driver Name</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Driver No.</th>
            </tr>
          </thead>
          <tbody>
            {currentOrders.map((order, index) => (
              <tr key={order.id} className="border-b hover:bg-gray-50">
                <td
                  className="px-4 py-3 text-sm text-yellow font-inter cursor-pointer"

                >
                  <EllipsisVerticalIcon
                    className="h-5 w-5"
                    onClick={() => toggleDropdown(order.orderId)}
                  />
                  {dropdownOpenId === order.orderId && (
                    <div className="ao-action-menu absolute bg-white shadow rounded p-2">
                      <button className="block w-full text-left px-2 py-1 hover:text-yellow text-gray-700" onClick={() => openModal(order)}>Edit</button>
                      <hr className="w-full border-gray-200 my-2" />
                      <button className="block w-full text-left px-2 py-1 text-red-600 hover:text-yellow text-gray-700" onClick={() => handleDeleteClick(order)}>Delete</button>
                    </div>
                  )}
                </td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.orderNumber}</td>
                <td className="px-4 py-3">
                  <span
                    className={`px-2 py-1 font-inter font-medium rounded-full text-sm ${getStatusClass(
                      order.orderStatus?.name
                    )}`}
                  >
                    {order.orderStatus?.name}
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">
                  {formatDate(order.date)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">
                  {order.timeCreated}
                </td>
                <td className="px-4 py-3">{order.businessName ? order.businessName : "Butler"}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">
                  {order.customerName}
                </td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">
                  {order.customerPhoneNumber}
                </td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">
                  {order.driverName}
                </td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">
                  {order.driverPhoneNumber}
                </td>
              </tr>
            ))}
          </tbody>
        </table>}
        <div className="data-pagination bg-grey mb-0 w-full flex justify-between border-t border-l pl-3 border-r pr-3 pt-3 items-center md:flex-row justify-between pt-4">
          <span className="text-sm font-medium">
            Showing {filteredOrders.length ? (currentPage - 1) * rowsPerPage + 1 : 0}-{Math.min(currentPage * rowsPerPage, filteredOrders.length)} of{' '}
            {filteredOrders.length}
          </span>
          <TablePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
      </div>
      <div className="data-endcap">



        {/* Modal */}
{isModalOpen && selectedOrder && (
  <div className="order-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="order-modal-panel bg-white w-full max-w-4xl rounded-lg shadow-lg p-6 overflow-y-auto max-h-[90vh]">
      <h2 className="text-lg font-semibold mb-4">Order Details</h2>
      <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

      {/* Other Order Details */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
        <select
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
          value={selectedStatus}
          onChange={(e) => changeOrderStatus(e.target)} // Handle status change
        >
          {/* Display the selected order's status */}
          <option disabled value={selectedStatus}>
            {selectedStatus}
          </option>
          {/* Render other statuses */}
          {statuses
            .sort((a, b) => a.value - b.value) // Sort by value in ascending order
            .map((status) => (
              <option
                disabled={status.label === selectedStatus}
                key={status.value}
                value={status.value}
              >
                {status.label}
              </option>
            ))}
        </select>

        {selectedOrder.promoCode && selectedOrder.promoCode.code && <label className="block text-sm font-medium text-gray-700 mb-1">Discount</label>}
        {selectedOrder.promoCode && selectedOrder.promoCode.code && <input
          type="text"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
          defaultValue={selectedOrder.promoCode.amount+"%"}
        />}

<label className="block text-sm font-medium text-gray-700 mb-1">SubTotkkal</label>
        <input
          type="text"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
          defaultValue={
            selectedOrder
            ? ((Number(selectedOrder.totalAmount) - (Number(selectedOrder.deliveryCharge) / 89500)) + 0.001).toFixed(2)
            : "0.00"
          
          
          
          }
        />

        
        <label className="block text-sm font-medium text-gray-700 mb-1">Delivery Charge</label>
        <input
          type="text"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
          defaultValue={selectedOrder.deliveryCharge}
        />
        
        <label className="block text-sm font-medium text-gray-700 mb-1">Total Amount</label>
        <input
          type="text"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
          defaultValue={selectedOrder.totalAmount}
        /> 
      </div>

      {/* Displaying Address Details */}
      {!selectedOrder.pickup ? <div className="mb-4">
        <h4 className="text-md font-semibold mb-2">Address Details</h4>
        {selectedOrder?.address?.street && <p className="text-sm text-gray-700">
          <strong>Street:</strong> {selectedOrder?.address?.street || "N/A"}
        </p>}
        {selectedOrder?.address?.building && <p className="text-sm text-gray-700">
          <strong>Building:</strong> {selectedOrder?.address?.building || "N/A"}
        </p>}
        {selectedOrder?.address?.apartment && <p className="text-sm text-gray-700">
          <strong>Apartment:</strong> {selectedOrder?.address?.apartment || "N/A"}
        </p>}
        {selectedOrder?.address?.instructions && <p className="text-sm text-gray-700">
          <strong>Instructions:</strong> {selectedOrder?.address?.instructions || "N/A"}
        </p>}
        {selectedOrder?.address?.google_map_coordinates && <p className="text-sm text-gray-700">
          <strong>Location:</strong>
          <a
            href={`https://www.google.com/maps?q=${selectedOrder?.address?.google_map_coordinates.x},${selectedOrder?.address?.google_map_coordinates.z}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            View on Google Maps
          </a>
        </p>}
      </div>:<div className="mb-4"> <h4 className="text-md font-semibold mb-2">Address Details</h4><p>Store Pickup</p></div>}

      {/* Displaying Address Details */}
      {selectedOrder.addressTo && <div className="mb-4">
        <h4 className="text-md font-semibold mb-2">To Address Details</h4>
        {selectedOrder?.addressTo?.street && <p className="text-sm text-gray-700">
          <strong>Street:</strong> {selectedOrder?.addressTo?.street || "N/A"}
        </p>}
        {selectedOrder?.addressTo?.building && <p className="text-sm text-gray-700">
          <strong>Building:</strong> {selectedOrder?.addressTo?.building || "N/A"}
        </p>}
        {selectedOrder?.addressTo?.apartment && <p className="text-sm text-gray-700">
          <strong>Apartment:</strong> {selectedOrder?.addressTo?.apartment || "N/A"}
        </p>}
        {selectedOrder?.addressTo?.instructions && <p className="text-sm text-gray-700">
          <strong>Instructions:</strong> {selectedOrder?.addressTo?.instructions || "N/A"}
        </p>}
        {selectedOrder?.addressTo?.google_map_coordinates && <p className="text-sm text-gray-700">
          <strong>Location:</strong>
          <a
            href={`https://www.google.com/maps?q=${selectedOrder?.addressTo?.google_map_coordinates.x},${selectedOrder?.addressTo?.google_map_coordinates.z}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            View on Google Maps
          </a>
        </p>}
      </div>}

      {/* Items List */}
      <div className="mb-4">
        <div className="mb-6">
          <h3 className="text-sm font-medium text-gray-700 mb-2">Items</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {selectedOrder.carts.map((item, index) => (
              <div
                key={index}
                className="flex items-center rounded-lg p-3"
              >
                {/* Item Image */}
                <img
                  src={item.product && item.product.image}
                  alt={item.product && item.product.name}
                  onClick={() => handleImageClick(item.product.image)}
                  className="w-16 h-16 rounded-lg object-cover mr-4"
                />
                {/* Item Details */}
                <div className="flex flex-col flex-grow">
                <div className="text-xs text-gray-600 font-bold"> {item.product.name}</div>
                  <div className="text-xs text-gray-600">Quantity: {item.quantity}</div>
                  <div style={{ width: 300 }}>
                    {item?.notes?.split('\n').map((line, index) => (
                      <p className="text-xs text-gray-600" key={index}>{line}</p>  // Render each line in a separate <p> tag
                    ))}
                  </div>
                  {/* Buttons: Edit and Delete */}
                  <div className="flex space-x-2 mt-2">
                    {/* Edit Button */}
                    <button
                      className="flex border border-darkGrey items-center justify-center w-8 h-8 text-white rounded-lg hover:border-yellow transition"
                      onClick={() => handleEditItem(item)}
                    >
                      <PencilIcon className="w-4 h-4 text-darkGrey hover:text-yellow " />
                    </button>

                    {/* Delete Button */}
                    <button
                      className="flex border border-darkGrey items-center justify-center w-8 h-8 text-white rounded-lg hover:border-yellow transition"
                      onClick={() => handleDeleteItem(index)}
                    >
                      <TrashIcon className="w-4 h-4 text-darkGrey hover:text-yellow  " />
                    </button>
                  </div>
                </div>
              </div>
            ))}
            {selectedOrder.items.map((item, index) => (
              <div
                key={index}
                className="flex items-center rounded-lg p-3"
              >
                {/* Item Image */}
                <img
                  src={item && item.image}
                  alt={item && item.name}
                  onClick={() => handleImageClick(item.image)}
                  className="w-16 h-16 rounded-lg object-cover mr-4"
                />
                {/* Item Details */}
                <div className="flex flex-col flex-grow">
                <div className="text-xs text-gray-600 font-bold"> {item.name}</div>
                 
                  <div style={{ width: 300 }}>
                    {item?.notes?.split('\n').map((line, index) => (
                      <p className="text-xs text-gray-600" key={index}>{line}</p>  // Render each line in a separate <p> tag
                    ))}
                  </div>
                  {/* Buttons: Edit and Delete */}
                  <div className="flex space-x-2 mt-2">
                    {/* Edit Button */}
                 

                    {/* Delete Button */}
                   
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Other Information */}
      {selectedOrder.promoCode && <div className="flex">
        <label className="block text-sm font-bold text-gray-700 mb-1">PromoCode:  </label>
        <label className="block text-sm font-medium text-gray-700 mb-1"> {selectedOrder.promoCode.code} {selectedOrder.promoCode.amount}% </label>
      </div>}
      {selectedOrder.receiverNumber && <div className="flex">
        <label className="block text-sm font-bold text-gray-700 mb-1">Receiver Number: </label>
        <label className="block text-sm font-medium text-gray-700 mb-1"> {selectedOrder.receiverNumber}</label>
      </div>}
      <label className="block text-sm font-bold text-gray-700 mb-1">Notes</label>
      {selectedOrder.leaveWithDoorMan && <label className="block text-sm font-medium text-gray-700 mb-1">Leave With the Door Man</label>}
      {selectedOrder.ringTheBell && <label className="block text-sm font-medium text-gray-700 mb-1">Don't ring the bell</label>}
      {selectedOrder.callMe && <label className="block text-sm font-medium text-gray-700 mb-1">Call when you arrive</label>}

      <textarea
        className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
        rows="3"
        defaultValue={selectedOrder.notes}
      ></textarea>

      <div className="flex justify-center space-x-2">
        <button
          className="px-5 py-1 bg-white border font-inter border-gray-700 text-gray-700 text-sm rounded-lg hover:bg-yellow hover:text-white hover:border-white"
          onClick={() => handleEditOrder(selectedOrder)}
        >
          SAVE
        </button>
        <button className="px-5 py-1 bg-white font-inter  border border-gray-700 text-gray-700 text-sm rounded-lg hover:bg-yellow hover:text-white hover:border-white"
          onClick={closeModal}>
          CANCEL
        </button>
      </div>
    </div>
  </div>
)}


        {/* Modal for Enlarged Image */}
        {isModalImageOpen && (
          <div className="order-modal-backdrop fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="order-dialog-panel bg-white p-6 rounded-lg shadow-lg max-w-3xl">
              <img
                src={selectedImage}
                alt="Enlarged view"
                className="max-w-full max-h-full object-contain"
              />
              <button
                className="absolute top-2 right-2 text-white bg-red-500 rounded-full p-2"
                onClick={closeModalImage}
              >
                Close
              </button>
            </div>
          </div>
        )}


        {/* Edit Quantity Modal */}
        {isEditModalOpen && currentItem && (
          <div className="order-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="order-dialog-panel bg-white rounded-lg shadow-lg p-6 w-96">
              <h3 className="text-lg font-semibold mb-4">Edit Quantity</h3>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Quantity</label>
                <input
                  type="number"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  value={newQuantity}
                  onChange={(e) => setNewQuantity(e.target.value)}
                />
              </div>
              <div className="flex justify-end space-x-2 mt-4">
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => setIsEditModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => handleSaveQuantity(selectedOrder.customer.customerId)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Confirmation Modal */}
        {showConfirmModal && (
          <div className="order-modal-backdrop fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="order-dialog-panel bg-white p-6 rounded-lg shadow-lg">
              <p className="text-lg font-semibold mb-4">
                Are you sure you want to delete this order?
              </p>
              <div className="flex justify-end space-x-4">
                <button
                  className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow "
                  onClick={cancelDelete}
                >
                  No
                </button>
                <button
                  className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow"
                  onClick={confirmDelete}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </Layout>
  );
};

export default AllOrders;
